const PIS_COFINS_CSLL_TYPE = '8'
const PIS_COFINS_CSLL_TYPE_PIS_NAME = 'PIS'
const PIS_COFINS_CSLL_TYPE_COFINS_NAME = 'COFINS'
const PIS_COFINS_CSLL_TYPE_CSLL_NAME = 'CSLL'

export default {
  PIS_COFINS_CSLL_TYPE,
  PIS_COFINS_CSLL_TYPE_PIS_NAME,
  PIS_COFINS_CSLL_TYPE_COFINS_NAME,
  PIS_COFINS_CSLL_TYPE_CSLL_NAME,
}
